import type { RootState } from "@/store";

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectIsLoading = (state: RootState) => state.auth.isLoading;
export const selectError = (state: RootState) => state.auth.error;
export const selectAuthStep = (state: RootState) => state.auth.authStep;
export const selectRequiresNewPassword = (state: RootState) => state.auth.requiresNewPassword;
export const selectUser = (state: RootState) => state.auth.user;
export const selectUserAttributes = (state: RootState) => state.auth.userAttributes;